import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealerLeadEnquiriesService } from '../../../services/models';
import { BaseListComponent } from '../../base/base.list.component';

@Component({
    templateUrl: './dealer-lead-enquiries.component.html'
})

export class  DealerLeadEnquiriesComponent extends BaseListComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private dealerService: DealerLeadEnquiriesService,
        protected injector: Injector
    ) { 
        super(dealerService, injector, 'dealers');
        let id = this.route.snapshot.paramMap.get('id');

        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 25,
            ajax: this.getAjaxConfig('dealer_lead_enquiries'),
            "columns": [
                // {
                //     data: "id",
                //     title: "ID"
                // },
                {
                    data: "firstname",
                    title: "First Name"
                },
                {
                    data: "lastname",
                    title: "Last Name"
                },
                {
                    data: "email",
                    title: "Email",
                   
                },
                {
                    data: "contact_number",
                    title: "Mobile Number"
                },
                {
                    data: "enquiries",
                    title: "Type of Enquiry"
                },
                {
                    data: "state",
                    title: "State"
                },
                {
                    data: "dealer_name",
                    title: "Dealer Name"
                },
                {
                    data: "additional_info",
                    title: "Additional Info"
                },
                    
                {
                    data: "created_at",
                    title: "Email Send"
                },
                {
                    data: "email_status",
                    title: "Email Status"
                },
                {
                    data: "email_open_date",
                    title: "Email Opened",
                    defaultContent: "-"
                },
                {
                    title: 'Action',
                    orderable: false,
                    render: function (data: any, type: any, full: any) {
                        return '<a class="btn btn-primary">View</a>&nbsp;&nbsp;<a " class="btn btn-danger">Delete</a>';
                    }
                }
            ]
        }
    }
    
    ngOnInit() {

    }
    ngAfterViewInit(): void {
        this.bindListeners();
    }
    ngOnDestroy() {
        this.clearListeners();
    }
   
    public export():void {
      
            this.dealerService.getExport()
            .subscribe((data) => {

                // let fileName = data.headers.get('content-disposition')?.split(';')[1].split('=')[1];
                // let blob:Blob=data.body as Blob;
                let blob:Blob = new Blob([data],{
                    type:''
                });
                var downloadURL = window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = downloadURL;
                link.download = "dealer-enquiries.csv";
                link.click();
              
              });
            }
              
}
